import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ViewChild, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { CategoryService } from 'src/app/_services/category.service';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { MatDialog } from '@angular/material/dialog';
import { User } from 'src/app/_models';
import { DocumentService } from 'src/app/_services/document.services';
import { MatTableDataSource } from '@angular/material/table';
import { Document } from 'src/app/_models/document';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { DialogDeleteConfirmComponent } from 'src/app/dialog-delete-confirm/dialog-delete-confirm.component';
import { environment } from '@environments/environment';
import { WorkflowService } from 'src/app/_services/workflow.service';
import { AppConfig } from 'src/assets/config/config/app-config';
import { VirtualFolderService } from 'src/app/_services/virtualFolder.service';


import cloneDeep from 'lodash/cloneDeep';
import { AlertService } from 'src/app/_services/alert.service';
import { UsersAndGroupsService } from 'src/app/_services/users-and-groups.service';

@Component({
  selector: 'app-display-search-doc',
  templateUrl: './display-search-doc.component.html',
  styleUrls: ['./display-search-doc.component.scss']
})
export class DisplaySearchDocComponent implements OnInit {

  @Input() selectedDocument: any;
  @Input() categoryPermissions: any;
  @Input() currentTask;
  @Input() docVersionNumber: any;
  @Input() taskID: number;
  @Input() searchResultsList: any;
  @Input() allCategoriesList: any;
  @Input() searchText: string;
  @Output() hideDocList = new EventEmitter<boolean>();
  @Output() fetchedCategoryName = new EventEmitter<string>();
  @Output() fetchedCategoryID = new EventEmitter<any>();
  @Output() docId = new EventEmitter<boolean>();
  @Output() hideDocListWithCategoryChange = new EventEmitter<object>();
  @Input() showSearchDocList = true;

  ngOnChanges(changes: SimpleChanges) {
    this.documentID = this.selectedDocument;
  }

  editClicked: boolean = false;
  displayedColumns = ["versionNumber", "fileName", "actions"];
  isUpdateCategory: Boolean = false;
  uploadMessage: Boolean = false;
  documentDetails: Document = null;
  docName: String;
  documentProp: String[];
  propertyCols: String[];
  fetchData: Boolean = false;
  selectedHeader: number;
  metadataBtnLabel: String = "Metadata";
  hideDocView: Boolean = false;
  //hideDocList: Boolean = false;
  allUsers
  currentUser: User
  documentVersions: any;  
  isLockUser: boolean = false
  isUpdatedCategory: boolean = false;
  isRecordsManager: boolean = false;
  userGroups: string[];
  openMetaData: boolean = false;
  selectedRow: Array<JSON> = [];
  searchResultsCols: String[] = ["categoryName", "documentName", "versionNum"];
  documentID: string;
  url: string;
  isUpdateDocumentTitle: boolean = false;
  activeDocumentDetails: any;
  isDeleteGroup: boolean = false
  openUpload: boolean = false;
  openHistory: boolean = false;
  openCommentTab: boolean = false;
  propertyKeys: String[] = [];
  values: any[];
  properties: any;
  close: boolean = false;
  isVersionsNotAvailable: boolean = false;
  versionWarning: string = '';
  versionError: string = '';
  versionNumber: number;
  openOnlyRedact: boolean = false;
  openRedactDocumentTab: boolean = false
  workflowProcesses: number
  enableWorkflow :boolean = this.config.getConfig("enableWorkflow")
  enableImageTrust: boolean = this.config.getConfig("enableImageTrust")

  isDocumentRedactable: Boolean = false; //tells us if the document belongs to a category in which it can be redacted
  isDocRedactionEnabled: Boolean = false;
  isDocTypeCorrectForRedact: Boolean = false;
  isDocAlreadyRedacted: Boolean = false;
  doesDocumentNameContainRedacted: Boolean = false;
  redactionStatus = null;
  redactionStatusCategory = 'N/A';
  documentInReview = true;
  showRedaction = false;
  allCatMappings = [];
  allVirtualFoldersList = [];
  isUpdateGroup: boolean = false;
  redactDialogRef;
  publicLink;

  openShareLinkTab:boolean = false; 
  message = ""
  aclGroup: any = this.config.getACLGroup();
  openQuestionAnswer:boolean = false;

  sort;
  @ViewChild(MatSort, { static: false }) set content(content: any) {
    this.sort = content;
    if (this.sort) {
      this.searchResultsList.sort = this.sort;
    }
  }

  paginator;
  @ViewChild(MatPaginator, { static: false }) set pageContent(content: any) {
    this.paginator = content;
    if (this.paginator) {
      this.searchResultsList.paginator = this.paginator;
    }
  }

  @ViewChild('redactionPopup', { static: false } ) redactionPopup: TemplateRef<any>;

  constructor(
    private documentSvc: DocumentService,
    private authenticationService: AuthenticationService,
    public dialog: MatDialog,
    private cdref: ChangeDetectorRef,
    private categoryService: CategoryService,
    private workflowService: WorkflowService,
    private config: AppConfig,
    private alertService: AlertService,
    private vfService: VirtualFolderService,
    private groupService: UsersAndGroupsService
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
    this.userGroups = this.authenticationService.userGroupsValue;    
  }

  async ngOnInit(): Promise<void> {
    this.showRedaction = this.config.getConfig('showRedaction');
    this.documentID = this.selectedDocument;
    this.allVirtualFoldersList = await this.vfService.getFlattenedTree();
    if (this.showRedaction) {
      this.categoryService.getCategoryMapping().subscribe((mappings) => {
        this.allCatMappings = mappings['Entities'];
      });
    }    
    this.fetchServiceData();
    // if (this.enableWorkflow) {
    //   this.getProcessIdForDocumentHandler(this.documentID)
    // }
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  showVersionDocument(event, row) {
    this.documentID = row.documentId;
    this.docVersionNumber = row.VersionNumber
    this.fetchServiceData();
  }

  getDocDetails(event, row) {
    this.documentID = row.documentId
    this.docVersionNumber = row.VersionNumber
    this.fetchServiceData();
  }

  showDocList() {
    this.hideDocList.emit(false);
    this.hideDocView = true;
  }

  eventSuccessHandler(){
    this.docVersionNumber = undefined
    this.fetchServiceData();
  }

  refreshDocumentDetails() {
    this.docVersionNumber = undefined
    this.openCommentTab = false;
    this.openHistory = false
    this.openMetaData = false
    this.openUpload = false
    this.openOnlyRedact = false;
    this.openRedactDocumentTab = false;
    this.documentID = this.selectedDocument;
    this.documentInReview = true;
    this.fetchServiceData();
  }

  fetchServiceData() {
    this.hideDocView = true
    this.documentSvc.getDocumentDetails(this.documentID)
      .subscribe(details => {
        this.hideDocView = false;
        this.activeDocumentDetails = details;
        this.activeDocumentDetails.categoryMetaData.properties.forEach(element => {
          this.propertyKeys.push(element.name)
        });
        
        this.values = Object.assign(this.activeDocumentDetails.metadata.properties)
        this.activeDocumentDetails.categoryMetaData.properties.forEach(
          async (element, index) => {
          // if (element.data_type == "date") {
          //   if (this.values[element.name]) {
          //     var dateArray = this.values[element.name].split("/")
          //     var date = dateArray[2] + "-" + dateArray[0] + "-" + dateArray[1]
          //     this.values[element.name] = date
          //   }
          // }
          
          if (element.name == 'Enable Redaction') {
            this.isDocumentRedactable = true;
            this.isDocRedactionEnabled = this.values[element.name];
            const docType =
              this.activeDocumentDetails['metadata']['system']['type'];
            if (
              docType &&
              (docType.includes('pdf') ||
                docType.includes('png') ||
                docType.includes('jpg') ||
                docType.includes('jpeg'))
            ) {
              this.isDocTypeCorrectForRedact = true;
            }
            this.doesDocumentNameContainRedacted =
              this.activeDocumentDetails.documentName
                .toLowerCase()
                .includes('redacted');
            this.isDocAlreadyRedacted =
              this.doesDocumentNameContainRedacted ||
              this.values[element.name]
                ? true
                : false;
            if (
              this.isDocumentRedactable &&
              !this.doesDocumentNameContainRedacted
            ) {
              let currMapping = (
                await this.categoryService
                  .getCategoryMappingById(details['categoryId'])
                  .toPromise()
              )['Entities'][0];
              let virtualFoldersArray = currMapping['Review ID'].split(',');
              let redactCatName = null;
              let reviewVfName = null;
              if (this.allCategoriesList && currMapping) {
                redactCatName = this.allCategoriesList.find(
                  (cat) => cat['id'] == currMapping['redactDestId']
                )['name'];
                reviewVfName = this.allVirtualFoldersList.find(
                  (vf) => vf['id'] == virtualFoldersArray[2]
                )['folder_name'];
              }

              const res = this.documentSvc
                .getRedactionStatus(this.documentID)
                .subscribe(async (status) => {
                  if (
                    status &&
                    status['Redaction Status']
                      .toLowerCase()
                      .includes('completed')
                  ) {
                    let redactDocResp = await this.documentSvc
                      .getDocumentDetails(status['Redaction Id'])
                      .toPromise();
                    if (
                      redactDocResp['metadata']['properties']['Passed Review']
                    ) {
                      this.documentInReview = false;
                      this.redactionStatusCategory = redactCatName
                        ? redactCatName
                        : 'N/A';
                    } else {
                      this.redactionStatusCategory = reviewVfName
                        ? reviewVfName
                        : 'N/A';
                    }
                  }
                  this.redactionStatus = status;
                });
            } else if (
              this.isDocumentRedactable &&
              this.doesDocumentNameContainRedacted
            ) {
              this.redactionStatus = {
                'Redaction Status': 'Completed',
              };
            }
          }
        }
      );
        this.properties = {}
        this.propertyKeys.forEach(key => {
          if (this.values[String(key)]) {
            this.properties[String(key)] = this.values[String(key)]
          } else {
            this.properties[String(key)] = undefined
          }
        })
        if (details.locked == true && details.locked_by != this.currentUser.username) {
          this.isLockUser = true
        }
        this.fetchDocumentVersions();
        this.fetchUserGroups();        
      });
  }

  fetchDocumentVersions() {
    this.fetchData = false;
    this.documentDetails = null;
    this.isVersionsNotAvailable = false;
    this.versionWarning = '';
    this.versionError = '';
    if (this.docVersionNumber == null) {
      this.docVersionNumber = this.activeDocumentDetails.activeVersion;
    }
    this.documentSvc.getDocumentVersions(this.documentID)
      .subscribe((versions: Document[]) => {
        this.documentVersions = new MatTableDataSource(versions || []);
        if (!versions || versions.length === 0) {
          this.isVersionsNotAvailable = true;
          this.versionError = 'No versions are available for this document.';
          return;
        }
        let selectedVersion = versions.find(
          version => Number(version.VersionNumber) === Number(this.docVersionNumber)
        );
        if (!selectedVersion) {
          selectedVersion = versions.find(
            version => Number(version.VersionNumber) === Number(this.activeDocumentDetails.activeVersion)
          );
          if (!selectedVersion) {
            this.isVersionsNotAvailable = true;
            this.versionError = 'The requested version and active version are unavailable for this document.';
            return;
          }
          this.versionWarning = `Requested version ${this.docVersionNumber} is unavailable. Showing active version ${selectedVersion.VersionNumber}. The search result may be out of date.`;
        }
        this.docVersionNumber = selectedVersion.VersionNumber;
        this.documentDetails = selectedVersion;
        this.documentProp = this.documentDetails.metadata.properties;
        this.propertyCols = Object.keys(this.documentDetails.metadata.properties);
        this.publicLink = this.config.getConfig("publicURL") + `documentId=${this.documentDetails.documentId}&fileType=${this.documentDetails.metadata.system.type}&userType=public`;
        this.fetchData = true;
      }, () => {
        this.isVersionsNotAvailable = true;
        this.versionError = 'Unable to load document versions. Please return to the results and try again.';
        this.alertService.error(this.versionError);
      });
  }

  fetchUserGroups() {
    if (this.userGroups) {
      var adminGroup;           
      this.groupService.getAdminGroupName().subscribe(admin => {
          adminGroup = admin
          this.userGroups.forEach(group => {
              if (adminGroup.includes(group)) {                 
                  this.isRecordsManager = true;
              }
          })
      });
      if (this.categoryPermissions === undefined || this.categoryPermissions === null) {
        this.categoryService.get(this.activeDocumentDetails.categoryId).subscribe(categoryDetails => {
          this.categoryPermissions = categoryDetails.permissions
          //var recordsManagementAdminGroup = this.config.getRecordsManagementAdminGroup()
          this.userGroups.forEach(userGroup => {
            // if (userGroup == recordsManagementAdminGroup) {
            //   this.isRecordsManager = true;

            // }
            this.categoryPermissions.delete_document.forEach(
              (updateGroup) => {
                if (userGroup == updateGroup) {
                  this.isUpdateGroup = true;
                }
              }
            );
            this.categoryPermissions.delete_document.forEach(deleteGroup => {
              if (userGroup == deleteGroup) {
                this.isDeleteGroup = true;
              }
            });
          })
        })
      } else {
        // var recordsManagementAdminGroup = this.config.getRecordsManagementAdminGroup()
        this.userGroups.forEach(userGroup => {
          // if (userGroup == recordsManagementAdminGroup) {
          //   this.isRecordsManager = true;
          // }
          this.categoryPermissions.update_document.forEach(
            (updateGroup) => {
              if (userGroup == updateGroup) {
                this.isUpdateGroup = true;
              }
            }
          );
          this.categoryPermissions.delete_document.forEach(deleteGroup => {
            if (userGroup == deleteGroup) {
              this.isDeleteGroup = true
            }
          });
        })
      }
    }
  }

  updateCategory() {
    this.isUpdateCategory = true
    this.editClicked = true
    this.openMetaData = false
    this.openShareLinkTab = false
  }

  updateDocumentTitle() {
    this.isUpdateDocumentTitle = true
    this.editClicked = true
    this.openMetaData = false
    this.isUpdateCategory = false
    this.openShareLinkTab = false
  }

  openImageTrust() {
    var apiUrl = this.config.getConfig("apiUrl")
    if (apiUrl === "https://km0gvq0iu0.execute-api.us-east-2.amazonaws.com/dev") {
      this.url = `http://in-ith-web.s3-website.us-east-2.amazonaws.com/docuedge-imagetrust-operations.html?&docId=${this.documentID}&dms_user=${this.currentUser.username}&token=${this.currentUser.token}&environment=DocuEdge-Dev`
      window.open(this.url, "_blank");
    }
    else if (apiUrl === "https://il4p364yh4.execute-api.us-east-2.amazonaws.com/dev") {
      this.url = `http://in-ith-web.s3-website.us-east-2.amazonaws.com/docuedge-imagetrust-operations.html?&docId=${this.documentID}&dms_user=${this.currentUser.username}&token=${this.currentUser.token}&environment=DocuEdge-Demo`
      window.open(this.url, "_blank");
    } else if (apiUrl === "https://mw0f6agaae.execute-api.us-east-2.amazonaws.com/demo") {
      var imagetrustUrl=this.config.getConfig("imageTrustUrl")
      this.url = `${imagetrustUrl}?&state=${this.documentID}&dms_user=${this.currentUser.username}&token=${this.currentUser.token}&environment=DocuEdge-Demo`
      window.open(this.url, "_blank");
      } else {
      alert("Unable to load ImageTrust Viewer, Please contact your system adminstrator")
    }
  }

  openUploadDocument() {
    if (!this.openUpload) {
      this.openUpload = true
      this.openHistory = false
      this.openOnlyRedact = false;
      this.openMetaData = false
      this.openCommentTab = false
      this.openRedactDocumentTab = false
      this.openShareLinkTab = false
    } else {
      this.openUpload = false
    }
  }

  openRedact() {
    if (!this.openOnlyRedact) {
      this.openOnlyRedact = true;
      this.openUpload = false;
      this.openHistory = false;
      this.openMetaData = false;
      this.openCommentTab = false;
      this.openRedactDocumentTab = false;
    } else {
      this.openOnlyRedact = false;
    }
  }
  backFromUpload(hide: boolean) {
    if (hide) {
      this.openUpload = true;
    }
    else {
      this.openUpload = false
      this.docVersionNumber = undefined
      this.fetchServiceData()
    }
  }

  openCommentSection() {
    if (!this.openCommentTab) {
      this.openCommentTab = true
      this.openUpload = false
      this.openHistory = false
      this.openOnlyRedact = false;
      this.openMetaData = false
      this.openRedactDocumentTab = false
      this.openShareLinkTab = false
    } else {
      this.openCommentTab = false
    }
  }

  backFromCommentSection(hide: boolean) {
    if (hide) {
      this.openCommentTab = true;
    }
    else {
      this.openCommentTab = false;
    }
  }

  openHistoryTab() {
    if (!this.openHistory) {
      this.openHistory = true;
      this.openUpload = false;
      this.openMetaData = false;
      this.openOnlyRedact = false;
      this.openCommentTab = false;
      this.openRedactDocumentTab = false
      this.openShareLinkTab = false
    } else {
      this.openHistory = false
    }
  }

  backFromHistoryTab(hide: boolean) {
    if (hide) {
      this.openHistory = true;
    }
    else {
      this.openHistory = false;
    }
  }

  openUpdateMetaData() {
    if (!this.openMetaData) {
      this.openMetaData = true
      this.openUpload = false
      this.openHistory = false
      this.openOnlyRedact = false;
      this.openCommentTab = false
      this.openRedactDocumentTab = false
      this.openShareLinkTab = false
    } else {
      this.openMetaData = false
    }
  }

  backFromMetaData(hide: boolean) {
    if (hide) {
      this.openMetaData = true;
    }
    else {
      this.openMetaData = false
      this.docVersionNumber = undefined
      this.fetchServiceData()
    }
  }

  lockUnlockDocument(lockStatus) {
    if (lockStatus) {
      this.documentSvc.unlockDocument(this.documentID)
        .subscribe(
          resp => {
            this.fetchServiceData()
          },
          error => {
            var errObj = JSON.parse(error.error)
            if (error.error['status'] = 400) {
            }
          });

    } else {
      this.openMetaData = false
      this.openUpload = false
      this.openOnlyRedact = false;
      this.documentSvc.lockDocument(this.documentID)
        .subscribe(
          resp => {
            this.fetchServiceData()
          },
          error => {
            var errObj = JSON.parse(error.error)
            if (error.error['status'] = 400) {
            }
          });
    }
  }

  onHideUpdateCategory(hide: boolean) {
    if (hide) {
      this.isUpdateCategory = true;
    } else {
      this.isUpdateCategory = false;
      this.fetchServiceData()
    }
  }

  onHideUpdateDocumentTitle(hide: boolean) {
    if (hide) {
      this.isUpdateDocumentTitle = true;
    } else {
      this.isUpdateDocumentTitle = false;
      this.fetchServiceData()
    }
  }

  onHideUpdatedCategory(hide: boolean) {
    if (hide) {
      this.uploadMessage = true;

    } else {
      this.uploadMessage = false;
    }
  }

  deleteDocument() {
    let dialogRef = this.dialog.open(DialogDeleteConfirmComponent,
      { width: '500px', data: { type: "Delete Document", payload: this.activeDocumentDetails.documentId } });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.showDocList()
      }
    })
  }

  deleteVersion(versionDetails) {
    var payload = {
      "document_id": versionDetails.documentId,
      "version": versionDetails.VersionNumber
    }
    let dialogRef = this.dialog.open(DialogDeleteConfirmComponent,
      { width: '500px', data: { type: "Delete Version", payload: payload } });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (versionDetails.VersionNumber == this.docVersionNumber) {
          this.docVersionNumber = this.activeDocumentDetails.activeVersion
        }
        this.fetchServiceData()
        this.fetchDocumentVersions()
      }
    })
  }

  activateVersion(versionDetails) {
    var payload = {
      "document_id": versionDetails.documentId,
      "version": versionDetails.VersionNumber
    }
    let dialogRef = this.dialog.open(DialogDeleteConfirmComponent,
      { width: '500px', data: { type: "Activate Version", payload: payload } });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.docVersionNumber = versionDetails.VersionNumber
        this.fetchServiceData()
        this.fetchDocumentVersions()
      }
    })
  }

  closeTabs(hide: boolean) {
    if (hide) {
      this.openMetaData = false
      this.openUpload = false
      this.openOnlyRedact = false
      this.openRedactDocumentTab = false
      this.openShareLinkTab = false
    }
  }

  shareDocumentLinkHandler(){
    if(!this.openShareLinkTab){
      this.openMetaData = false
      this.openUpload = false
      this.openHistory = false
      this.openCommentTab = false
      this.openOnlyRedact = false;
      this.openRedactDocumentTab = false
      this.openShareLinkTab = true
    } else{
      this.openShareLinkTab = false
    }
  }

  redactDocument() {
    if (!this.openRedactDocumentTab) {
      this.openMetaData = false
      this.openUpload = false
      this.openHistory = false
      this.openCommentTab = false
      this.openOnlyRedact = false;
      this.openRedactDocumentTab = true
      this.openShareLinkTab = false
    } else {
      this.openRedactDocumentTab = false
    }
  }

  backFromRedactDocumentTab(hide: boolean) {
    if (hide) {
      this.openRedactDocumentTab = true;
    } else {
      this.openRedactDocumentTab = false;
      this.docVersionNumber = this.activeDocumentDetails.activeVersion + 1;
      this.fetchServiceData();
      this.fetchDocumentVersions();
    }
  }

  getProcessIdForDocumentHandler(docId) {
    this.workflowService.getProcessesForDocument(docId).subscribe(resp => {
      if (resp['process-instance']) {
        this.workflowProcesses = resp['process-instance']
      }
    })
  }

  async updateRedactDoc() {
    //var updateReq = cloneDeep(this.activeDocumentDetails);
    var updateReq = {
      docId: this.activeDocumentDetails.documentId,
      category_id: this.activeDocumentDetails.categoryId,
      properties: {},
    };
    var props = cloneDeep(this.activeDocumentDetails['metadata']['properties']);
    //console.log(props, this.activeDocumentDetails.categoryMetaData);

    this.activeDocumentDetails.categoryMetaData.properties.forEach(
      (obj, index) => {
        if (obj.data_type === 'int') {
          props[obj.name] = parseInt(props[obj.name]);
        } else if (obj.data_type === 'date') {
          if (props[obj.name] == '' || props[obj.name] == null) {
            props[obj.name] = undefined;
          } else {
            var dateArray = props[obj.name].split('-');
            var date = dateArray[1] + '/' + dateArray[2] + '/' + dateArray[0];
            props[obj.name] = date;
          }
        } else if (obj.data_type == 'object') {
          props[obj.name] = props[obj.name];
        } else if (obj.data_type == 'bool') {
          props[obj.name] = false;
          if (props[obj.name]) {
            props[obj.name] = props[obj.name];
          }
        } else if (obj.data_type === 'str') {
          if (props[obj.name] == '' || props[obj.name] == null) {
            props[obj.name] = undefined;
          } else {
            props[obj.name] = props[obj.name];
          }
        } else if (obj.data_type == 'str array') {
          var values = [];
          if (props[obj.name].length == 0 || props[obj.name] == null) {
            props[obj.name] = undefined;
          } else {
            props[obj.name].forEach((element) => {
              values.push(element.value);
            });
            props[obj.name] = values;
          }
        } else {
          props[obj.name] = props[obj.name];
        }
      }
    );
    this.isDocRedactionEnabled = this.isDocRedactionEnabled ? false : true;
    props['Enable Redaction'] = this.isDocRedactionEnabled;
    updateReq.properties = props;

    // this.selectedDocument = '1c249c96-e005-46f3-b9f4-974b51e49bff'; //'a9f8fdd8-8284-4827-8040-79fc366bb72e';
    // this.ngOnInit2();
    //console.log(updateReq);
    if (this.isDocRedactionEnabled) {
      this.documentSvc
        .updateDocumentMetadata(updateReq)
        .subscribe(async (resp) => {
          // this.updateMessage = true;
          // this.toggleUpdate = false;
          var payload = {
            docID: this.activeDocumentDetails.documentId,
            asynchProcess: '1',
          };

          // this.documentSvc.sendDocumentForRedaction(payload).toPromise();
          //console.log("Document Metadata updated!");
          this.refreshDocumentDetails()
        }),
        (error) => {
          this.alertService.error(error);
        };
    }

    if (this.redactDialogRef) {
      this.redactDialogRef.close();
    }
  }

  cancelRedactToggle() {
    this.isDocRedactionEnabled =
      this.activeDocumentDetails.metadata.properties['Enable Redaction'];
  }

  openRedactionDialog() {
    //console.log('I AM BEING CALLED', this.redactionPopup)
    this.redactDialogRef = this.dialog.open(this.redactionPopup, {
      width: '500px',
    });
    // dialogRef.afterClosed().subscribe(result => {
    //   //console.log(`Dialog result: ${result}`);
    // });
  }

}
